<template>
  <d2-container class="test">
    <!-- 表格头部搜索 -->
    <template slot="header">
      <div style="width: 73%; display: flex; float: left; height: 48px">
        <span align="right" style="
            align: right;
            display: inline-block;
            width: 100px;
            line-height: 48px;
          ">关键字</span>
        <div style="padding: 8px 0px; width: 80%">
          <el-input clearable @keyup.enter.native="search()" style="margin-left: 10px; height: 48px" class="filter-item"
            placeholder="案号，当事人" v-model="CaseInfo.keyWord" size="small">
          </el-input>
        </div>

      </div>
      <div style="display: flex; justify-content: center; align-items: center;margin-top:10px">
        <div style="text-align: center">
          <el-button style="width: 5rem" class="filter-item" type="primary" round icon="search" @click.stop="search()"
            size="small">搜索</el-button>
          <el-button style="width: 5rem" class="filter-item" type="danger" round icon="search" @click.stop="resetTemp()"
            size="small">重置</el-button>

        </div>
      </div>
      <div style="display: flex"></div>
    </template>


    <!-- 批量备注 -->
    <el-dialog title="批量备注" :visible.sync="showNotes" width="30%" center :close-on-click-modal="false">
      <el-input type="textarea" :rows="12" placeholder="请输入内容" v-model="remark">
      </el-input>
      <div style="display: flex" class="notesBtn">
        <div>
          <el-button style="" type="primary" @click="batchRemark">确定</el-button>
        </div>
        <div>
          <el-button style="margin-left: 10px" type="" @click="showNotes = false">取消</el-button>
        </div>
      </div>
    </el-dialog>


    <!-- 新增案件 -->
    <div style="display: flex;">
      <span><el-button style="margin-left: 50px" class="filter-item" type="primary" icon="search"
          @click="showCreateCase" size="small">创建案件</el-button></span>
      <span style="margin-left: 50px"><el-upload ref="upload" :on-change="singFileChange"
          :http-request="singleUploadFile" accept=".xlsx,.xls" multiple :file-list="fileList" :limit="1">
          <el-button class="filter-item" type="primary" size="small">批量导入案件 <i class=""></i>
          </el-button>
        </el-upload></span>
      <span></span>



      <el-button @click="showNotes = true" style="margin-left: 50px" class="filter-item" type="primary" icon="search"
        v-show="false" size="small">批量备注</el-button>
      <span style="margin-left: 20px"> 表格高度： </span>
      <el-input style="width: 10%" type="number" v-model="tableHeight" @input="setTableHeight"
        placeholder="数字"></el-input>
    </div>




    <!-- 案件列表 -->
    <el-table v-loading.body="false" border type="index" :data="caseList" size="small" stripe :height="tableHeight"
      row-key highlight-current-row @selection-change="handleSelectionChange"
      style="width: 100vw; margin-top: 4px; overflow: auto">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column width="80" align="center" label="系统编号">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" label="案号">
        <template slot-scope="scope">
          <span>{{ scope.row.registerCode }}</span>
        </template>
      </el-table-column>

      <el-table-column width="250" align="center" label="当事人">
        <template slot-scope="scope">
          <div>{{ scope.row.plaintiffName }}</div>
          <el-link type="primary">{{ scope.row.defendantName }}</el-link>
        </template>
      </el-table-column>

      <el-table-column width="120" align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.caseStatus == '未提交'" type="info">{{
            scope.row.caseStatus
          }}</el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '提交法院'" type="warning">{{
            scope.row.caseStatus
          }}</el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '调解中'" type="danger">{{ scope.row.caseStatus }}
          </el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '调解成功'" type="primary">{{ scope.row.caseStatus }}
          </el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '已立案'" type="success">{{ scope.row.caseStatus }}
          </el-tag>
          <el-tag v-else type="danger">{{ scope.row.caseStatus }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column width="100" align="center" label="总标的">
        <template slot-scope="scope">
          <span>{{ scope.row.underlyingAmount }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column width="100" align="center" label="备注">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column> -->
      <el-table-column width="150" align="center" label="提交法院日期">
        <template slot-scope="scope">
          <div> {{ scope.row.courtSubDate }}</div>
        </template>
      </el-table-column>

      <el-table-column width="150" align="center" label="立案日期">
        <template slot-scope="scope">
          <span> {{ scope.row.filingDate }}</span>
        </template>
      </el-table-column>

      <el-table-column width="150" align="center" label="调解成功日期">
        <template slot-scope="scope">
          <span> {{ scope.row.mediationSuccessDate }}</span>
        </template>
      </el-table-column>


      <el-table-column fixed="right" align="center" label="操作" width="110">
        <template slot-scope="scope">
          <el-dropdown @command="handleCommand">
            <el-button type="danger">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="dataHandle(scope.$index, scope.row, '编辑')">编辑</el-dropdown-item>
              <el-dropdown-item v-if="scope.row.caseStatus == '提交法院'"
                :command="dataHandle(scope.$index, scope.row, '开始调解')">开始调解</el-dropdown-item>
              <el-dropdown-item v-if="scope.row.caseStatus == '调解中'"
                :command="dataHandle(scope.$index, scope.row, '调解成功')">调解成功</el-dropdown-item>
              <el-dropdown-item v-if="scope.row.caseStatus == '提交法院' || scope.row.caseStatus == '调解中'"
                :command="dataHandle(scope.$index, scope.row, '立案')">立案</el-dropdown-item>
              <el-dropdown-item :command="dataHandle(scope.$index, scope.row, '删除案件')">删除案件</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页 -->
    <template slot="footer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="CaseInfo.page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000]"
        :page-size="CaseInfo.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </template>

    <!-- 新增案件 -->
    <el-dialog :visible.sync="centerDialogVisible" :title="dialogStatus" width="40%" center
      :close-on-click-modal="false">
      <el-form :model="CaseForm" :rules="rules" ref="CaseForm" label-width="200px" class="demo-CaseForm">
        <el-form-item label="原告名称：" prop="plaintiffName">
          <el-select v-model="CaseForm.plaintiffName" placeholder="" style="width: 70%">
            <el-option label="广东御茂科技有限公司" value="广东御茂科技有限公司"></el-option>
            <el-option label="茂名市御美物业管理有限公司" value="茂名市御美物业管理有限公司"></el-option>
            <el-option label="茂名市电白区御景地产物业管理有限公司" value="茂名市电白区御景地产物业管理有限公司"></el-option>
            <el-option label="茂名市电白区御景地产物业管理有限公司滨海新区分公司" value="茂名市电白区御景地产物业管理有限公司滨海新区分公司"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="被告姓名：" prop="defendantName">
          <el-input v-model="CaseForm.defendantName" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="总标的：" prop="underlyingAmount">
          <el-input v-model="CaseForm.underlyingAmount" style="width: 70%" type="number" step="0.01"></el-input>
        </el-form-item>
        <el-form-item label="案件状态：" prop="caseStatus">
          <el-select v-model="CaseForm.caseStatus" placeholder="" style="width: 70%">
            <el-option label="提交法院" value="提交法院"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法院名称：" prop="courtName">
          <el-select v-model="CaseForm.courtName" placeholder="" style="width: 70%">
            <el-option label="茂名市电白区人民法院" value="茂名市电白区人民法院"></el-option>
            <el-option label="茂名市茂南区人民法院" value="茂名市茂南区人民法院"></el-option>
            <el-option label="化州市人民法院" value="化州市人民法院"></el-option>
            <el-option label="高州市人民法院" value="高州市人民法院"></el-option>
            <el-option label="信宜市人民法院" value="信宜市人民法院"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提交法院日期：" prop="courtSubDate">
          <el-date-picker style="width: 70%" v-model="CaseForm.courtSubDate" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <div class="center">
          <el-button class="" v-if="dialogStatus == '创建案件'" :disabled="btFlag" type="primary"
            @click="addCase()">立即创建</el-button>
          <el-button class="" v-if="dialogStatus == '编辑案件'" :disabled="btFlag" type="primary"
            @click="editCase()">更新案件</el-button>
          <el-button @click="resetForm('CaseForm')">重置</el-button>
          <el-button @click="centerDialogVisible = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>


    <!-- 立案 -->
    <el-dialog :close-on-click-modal="false" title="立案数据" :visible.sync="entryRegisterShow" width="40%" center>
      <el-row style="width: 100%">
        <el-col :span="6" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form ref="year" :model="registerModel" label-width="120" :rules="registerRule">
            <el-form-item label="案号:" prop="year">
              <el-select v-model="registerModel.year" placeholder="" style="width: 60%">
                <el-option label="2023" value="2023"></el-option>
                <el-option label="2024" value="2024"></el-option>
                <el-option label="2025" value="2025"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="5" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 7 }">
          <el-form ref="code" label-width="120" :model="registerModel" style="width: 100%" :rules="registerRule">
            <el-form-item label="粤" prop="code">
              <el-select v-model="registerModel.code" placeholder="" style="width: 70%">
                <el-option label="0902" value="0902"></el-option>
                <el-option label="0904" value="0904"></el-option>
                <el-option label="0981" value="0981"></el-option>
                <el-option label="0982" value="0982"></el-option>
                <el-option label="0983" value="0983"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form ref="registerCode" label-width="120" :model="registerModel" style="width: 100%"
            :rules="registerRule">
            <el-form-item label="民初" prop="registerCode">
              <el-input style="width: 60%" placeholder="" v-model="registerModel.registerCode"
                class="input-with-select">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="1" style="line-height: 40px"> 号 </el-col>
      </el-row>

      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="registerContent" :model="registerModel" label-width="120" :inline="true" style="width: 100%"
            :rules="registerRule">

            <el-form-item label="案件立案日期:" prop="filingDate">
              <el-date-picker style="width: 250px" v-model="registerModel.filingDate" type="date"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span style="width: 10rem" slot="footer" class="dialog-footer">
        <el-button @click="registerBoxShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="addRegister()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 调解成功 -->
    <el-dialog :close-on-click-modal="false" title="调解数据" :visible.sync="entryMediationShow" width="40%" center>
      <el-row style="width: 100%">
        <el-col :span="6" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form ref="mediationYear" :model="mediationModel" label-width="120" :rules="mediationRule">
            <el-form-item label="案号:" prop="year">
              <el-select v-model="mediationModel.year" placeholder="" style="width: 60%">
                <el-option label="2023" value="2023"></el-option>
                <el-option label="2024" value="2024"></el-option>
                <el-option label="2025" value="2025"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="5" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 7 }">
          <el-form ref="medCode" label-width="120" :model="mediationModel" style="width: 100%" :rules="mediationRule">
            <el-form-item label="粤" prop="medCode">
              <el-select v-model="mediationModel.medCode" placeholder="" style="width: 70%">
                <el-option label="0902" value="0902"></el-option>
                <el-option label="0904" value="0904"></el-option>
                <el-option label="0981" value="0981"></el-option>
                <el-option label="0982" value="0982"></el-option>
                <el-option label="0983" value="0983"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form ref="mediationNum" label-width="120" :model="mediationModel" style="width: 100%"
            :rules="mediationRule">
            <el-form-item label="诉前调书" prop="mediationNum">
              <el-input style="width: 60%" placeholder="" v-model="mediationModel.mediationNum"
                class="input-with-select">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="1" style="line-height: 40px"> 号 </el-col>
      </el-row>

      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="mediationContent" :model="mediationModel" label-width="120" :inline="true" style="width: 100%"
            :rules="mediationRule">

            <el-form-item label="调解成功时间:" prop="mediationSuccessDate" style="width: 100%">
              <el-date-picker style="width: 250px" v-model="mediationModel.mediationSuccessDate" type="date"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="调解金额:" prop="underlyingAmount" style="width: 100%">
              <el-input v-model="mediationModel.underlyingAmount" type="number" step="0.01"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span style="width: 10rem" slot="footer" class="dialog-footer">
        <el-button @click="entryMediationShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="addMediation()">确 定</el-button>
      </span>
    </el-dialog>


  </d2-container>
</template>
<style scoped>
@import "../../../assets/style/LiveCaseInfo/index.css";
</style>
<script>
import Vue from "vue";
import {
  page, addObj, getObj, putObj, delObj, transferToMediation, createCaseFiling, mediationSuccess, uploadTable

} from "@/api/czManager/wyCaseInfo/index";
import { downLoadFile } from '@/plugin/axios'
import store from "@/store";
import { uploadFile } from '@/plugin/axios';
import util from "@/libs/util";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showNotes: false,
      remark: "",
      tableHeight: '510',
      total: 0,
      registerRule: {
        year: [{
          required: true, message: '请选择年份', trigger: 'change'
        }],
        code: [
          {
            required: true, message: '请选择编号', trigger: 'change'
          }
        ],
        registerCode: [{
          required: true, message: '请输入案号', trigger: 'blur'
        }],
        filingDate: [{
          required: true, message: '请选择立案日期', trigger: 'change'
        }]
      },
      mediationRule: {
        mediationYear: [{
          required: true, message: '请选择年份', trigger: 'change'
        }],
        medCode: [
          {
            required: true, message: '请选择编号', trigger: 'change'
          }
        ],
        mediationNum: [{
          required: true, message: '请输入案号', trigger: 'blur'
        }],
        mediationSuccessDate: [{
          required: true, message: '请选择调解成功日期', trigger: 'change'
        }],
        underlyingAmount: [{
          required: true, message: '请输入调解金额', trigger: 'change'
        }]
      },
      entryRegisterShow: false,
      entryMediationShow: false,
      btFlag: false,

      rules: {
        plaintiffName: [{ required: true, message: "请选择原告名称", trigger: "blur" }],
        defendantName: [{ required: true, message: "请输入被告姓名", trigger: "blur" }],
        underlyingAmount: [{ required: true, message: "请输入案件总标的额", trigger: "blur" },],
        caseStatus: [{ required: true, message: "请选择案件状态", trigger: "blur" },],
        courtSubDate: [{ required: true, message: "请选择案件提交日期", trigger: "blur" }],
        courtName: [{ required: true, message: "请选择法院", trigger: "blur" }]
      },
      centerDialogVisible: false,
      registerModel: { year: "2024", code: "0902", registerCode: "" },
      mediationModel: { year: "2024", medCode: "0902", mediationNum: "", underlyingAmount: "" },
      CaseInfo: {
        keyWord: '',
        page: 1,
        limit: 50,
      },
      CaseForm: { id: "", plaintiffName: "", defendantName: "", underlyingAmount: "", caseStatus: "", courtSubDate: "", courtName: "" },
      listLoading: true,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      caseList: [],
      id: "",
      fileList: [],
      fileData: new FormData(),
    };
  },
  watch: {

  },
  created() {
    this.getList()
  },
  computed: {
  },
  methods: {

    showCreateCase() {
      this.resetFileList()
      this.CaseForm = { plaintiffName: "", defendantName: "", underlyingAmount: "", caseStatus: "提交法院", courtSubDate: "", courtName: "茂名市电白区人民法院" }
      this.centerDialogVisible = true
      this.dialogStatus = '创建案件'
    },
    showEditCase(id) {
      this.resetFileList()
      this.centerDialogVisible = true
      this.dialogStatus = '编辑案件'
      this.getCaseInfo(id)
    },


    resetFileList() {
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    singFileChange(file, fileList) {
      this.fileList = fileList
    },
    singleUploadFile(val) {
      let loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const token = util.cookies.get("token");
      this.fileData.append("file", val.file);
      uploadTable(this.fileData, token).then(res => {
        loading.close()
        if (res.data.statusCode === 2000) {
          this.$message({
            message: res.data.message,
            type: "success",
            duration: 15000,
          });
          this.getList()
          this.fileData = new FormData()
          this.fileList = []
        } else {
          this.$message.error('失败')
          this.fileData = new FormData()
          this.fileList = []
        }
      }).catch(err => {
        loading.close()
        this.$message.error('物业文件格式有问题或文件类型不符合')
        this.fileData = new FormData()
        this.fileList = []
      })
    },

    search() {
      this.getList()
    },
    //添加案件
    addCase() {
      addObj(this.CaseForm).then(res => {
        if (res.statusCode == 2000) {
          this.$message({ message: "录入成功", type: "success" });
          this.getList();
          this.centerDialogVisible = false;
          this.resetCaseForm()
        } else {
          this.$message({
            message: res.message,
            type: "error",
            duration: 5000,
          });
        }
      });
    },

    //编辑案件
    editCase() {
      putObj(this.CaseForm.id, this.CaseForm).then(res => {
        if (res.statusCode == 2000) {
          this.$message({ message: "修改成功", type: "success" });
          this.getList();
          this.centerDialogVisible = false;
          this.resetCaseForm()
        } else {
          this.$message({
            message: res.message,
            type: "error",
            duration: 5000,
          });
        }
      });
    },

    delCase(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delObj(id).then(res => {
          if (res.statusCode == 2000) {
            this.$message({ message: "删除", type: "success" });
            this.getList();
            this.centerDialogVisible = false;
            this.resetCaseForm()
          } else {
            this.$message({
              message: res.message,
              type: "error",
              duration: 5000,
            });
          }
        });
      })
    },

    //案件转调解
    transferToMediation(id) {
      this.$confirm('案件转调解状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        transferToMediation(id).then(res => {
          if (res.statusCode == 2000) {
            this.$message({ message: "修改成功", type: "success" });
            this.getList();
            this.centerDialogVisible = false;
            this.resetCaseForm()
          } else {
            this.$message({
              message: res.message,
              type: "error",
              duration: 5000,
            });
          }
        });
      })
    },

    //获取案件信息
    getCaseInfo(id) {
      getObj(id).then(res => {
        this.CaseForm = res;
        this.CaseForm.createTime = null
      });
    },

    //案件列表
    getList() {
      page(this.CaseInfo).then(response => {
        this.caseList = response.records;
        for (let i = 0; i < response.records.length; i++) {
          if (
            response.records[i].registerCode != null &&
            response.records[i].registerCode != undefined &&
            response.records[i].registerCode != ""
          ) {
            this.caseList[i].registerCode = response.records[i].registerCode;
          } else if (
            response.records[i].mediationCode != null &&
            response.records[i].mediationCode != undefined &&
            response.records[i].mediationCode != ""
          ) {
            this.caseList[i].registerCode = response.records[i].mediationCode;
          } else {
            this.caseList[i].registerCode = "";
          }
        }
        this.total = response.total;
      })
    },

    //封装数据
    dataHandle(index, row, command) {
      return { index: index, row: row, command: command };
    },

    //立案
    addRegister() {
      let yearFlag = false;
      let codeFlag = false;
      let contentFlag = false;
      let registerCodeFlag = false
      let registerCode = ''
      // this.$refs["paymentDate"].validate((valid) => { if (valid) { dateFlag = true; } });
      this.$refs["code"].validate((valid) => { if (valid) { codeFlag = true; } });
      this.$refs["registerCode"].validate((valid) => { if (valid) { registerCodeFlag = true; } });
      this.$refs["year"].validate((valid) => { if (valid) { yearFlag = true; } });
      this.$refs["registerContent"].validate((valid) => { if (valid) contentFlag = true })
      if (yearFlag == true && codeFlag == true && registerCodeFlag == true && contentFlag == true) {
        registerCode = `（${this.registerModel.year}）` + "粤" + this.registerModel.code + "民初" + this.registerModel.registerCode + "号";
      } else {
        this.$message({
          message: '参数有误',
          type: "error",
          duration: 5000,
        });
        return;
      }
      let req = { id: this.id, registerCode: registerCode, filingDate: this.registerModel.filingDate }
      createCaseFiling(req).then(res => {
        this.$message({ message: "操作完成", type: "success" });
        this.getList()
        this.entryRegisterShow = false
      }).catch(res => {
        this.$message({
          message: '操作失败',
          type: "error",
          duration: 5000,
        });
      })
    },

    addMediation() {
      let yearFlag = false;
      let codeFlag = false;
      let contentFlag = false;
      let mediationCodeFlag = false
      let mediationCode = ''
      this.$refs["medCode"].validate((valid) => { if (valid) { codeFlag = true; } });
      console.log(codeFlag)
      this.$refs["mediationNum"].validate((valid) => { if (valid) { mediationCodeFlag = true; } });
      this.$refs["mediationYear"].validate((valid) => { if (valid) { yearFlag = true; } });
      this.$refs["mediationContent"].validate((valid) => { if (valid) contentFlag = true })
      if (yearFlag == true && codeFlag == true && mediationCodeFlag == true && contentFlag == true) {
        mediationCode = `（${this.mediationModel.year}）` + "粤" + this.mediationModel.medCode + "民诉前调" + this.mediationModel.mediationNum + "号";
      } else {
        // this.$message({
        //   message: '参数有误',
        //   type: "error",
        //   duration: 5000,
        // });
        return;
      }
      let req = { id: this.id, mediationCode: mediationCode, mediationSuccessDate: this.mediationModel.mediationSuccessDate, underlyingAmount: this.mediationModel.underlyingAmount }
      mediationSuccess(req).then(res => {
        this.$message({ message: "操作完成", type: "success" });
        this.getList()
        this.entryMediationShow = false
      }).catch(res => {
        this.$message({
          message: '操作失败',
          type: "error",
          duration: 5000,
        });
      })
    },

    //下拉按钮事件
    handleCommand(command) {
      this.id = command.row.id;
      if (command.command == '编辑') {
        this.showEditCase(command.row.id)
      }
      if (command.command == '删除案件') {
        this.delCase(command.row.id)
      }
      if (command.command == '开始调解') {
        this.transferToMediation(command.row.id)
      }
      if (command.command == '立案') {
        this.entryRegisterShow = true
      }
      if (command.command == '调解成功') {
        this.entryMediationShow = true
      }

    },
    resetCaseForm() {
      this.CaseForm = { id: "", plaintiffName: "", defendantName: "", underlyingAmount: "", caseStatus: "", courtSubDate: "" }
    },
    handleSizeChange(val) {
      this.CaseInfo.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.CaseInfo.page = val;
      this.getList();
    },
  }
}
</script>
<style scoped>
* {}
</style>